import React, { useEffect, useState, useRef } from 'react'
import { useContentfulContext } from '../../../../contexts/ContentfulContext';
import PreviewTemplate from '../../PreviewTemplate';
import Loader from '../../../UI/Loader/Loader';

const PreviewMode = ({ rowData, handleOnClickCallback, handleCancelClick }) => {
    const { enums } = useContentfulContext();
    const [filteredRowData, setFilteredRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedTempData, setSelectedTempData] = useState();
    const [currentIndex, setCurrentIndex] = useState(0);
    const containerRef = useRef(null);

    useEffect(() => {
        const filteredData = rowData.filter((item) =>!item.isDisabled);
            setFilteredRowData(filteredData);
            setSelectedTempData(filteredData[0]);
            setCurrentIndex(0);
    }, [rowData])

    const handleNext = () => {
        setIsLoading(true);
        setSelectedTempData((prev) => {
            const currentIndex = filteredRowData.indexOf(prev);
            const newIndex = Math.min(currentIndex + 1, filteredRowData.length - 1);
            const newExpData = filteredRowData[newIndex];
            return newExpData;
        });
        setCurrentIndex((prev) => Math.min(prev + 1, filteredRowData.length - 1));
        setTimeout(() => setIsLoading(false), 500);
    };

    const handlePrevious = () => {
        setIsLoading(true);
        setSelectedTempData((prev) => {
            const currentIndex = filteredRowData.indexOf(prev);
            const newIndex = Math.max(currentIndex - 1, 0);
            const newExpData = filteredRowData[newIndex];
            return newExpData;
        });
        setCurrentIndex((prev) => Math.max(prev - 1, 0));
        setTimeout(() => setIsLoading(false), 500);
    };

    return (
        <div ref={containerRef}>
            {isLoading && <Loader />}
            {selectedTempData && (
                <PreviewTemplate
                    previewOnly={true}
                    cssCode={selectedTempData.css}
                    htmlCode={selectedTempData.html}
                    configJsonCode={selectedTempData.config_json}
                    jsonSchemaCode={selectedTempData.json_schema}
                    selectedTemplate={selectedTempData}
                    templateType={selectedTempData.type}
                    templatePlatform={selectedTempData.platform}
                    isLandscapeSupport={selectedTempData.landscape_support}
                    templateSource={selectedTempData.source}

                    isPreviewTitleBarEnable ={true}
                    title={selectedTempData.name}
                    handleBackwardArrowClick={selectedTempData !== filteredRowData[0] ? handlePrevious : null}
                    currentIndex={`${currentIndex + 1}/${filteredRowData?.length}`}
                    handleForwardArrowClick={selectedTempData !== filteredRowData[filteredRowData.length - 1] ? handleNext : null}
                    handleProcessedClick={() => handleOnClickCallback(selectedTempData)}
                    handleCancelClick={handleCancelClick}
                />
            )} 
        </div>
    )
}

export default PreviewMode